import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import { Box } from '@material-ui/core';
import UpArrowSVG from '../../assets/up_arrow.svg';
// import DownArrowSVG from '../../assets/down_arrow.svg';
import { detectClickOutside } from '../../utils/helpers';
import { useFocus } from '../../utils/hooks';
import useStyles from './RestaurantSelectorStyles';

/**
 * TODO put back in component library when styles are fixed
 */
export const RestaurantSelector = ({
  className,
  label,
  placeholder,
  items,
  style,
  onSelect,
  searchRestaurants,
  defaultValue,
  loading,
  endAdornment,
}) => {
  const classes = useStyles();

  const [isOpen, setOpen] = useState(false);
  const [input, setInput] = useState('');
  const [waiting, setWaiting] = useState(false); // Whether we are waiting for the timeout to send the input
  const [previousSelectedItem, setPreviousSelectedItem] = useState(null); // Useful if you need to return to a previous value
  const [selectedItem, setSelectedItem] = useState(defaultValue);
  const [inputRef, setInputFocus] = useFocus();

  const [typingTimeout, setTypingTimeout] = useState(0);

  useEffect(() => {
    setInput(defaultValue);
  }, [defaultValue]);

  // TODO useEffect to search restaurants while typing. Probably need loading spinner
  // TODO take this function from elsewhere

  // TODO if search returns no results, have a message that says so

  const isActive = document.activeElement === inputRef.current; // Whether the input is the active one
  const listRef = useRef(null);

  // Used for keyboard accessibility
  const onFocus = () => handleOpen();
  const onBlur = (event) => {
    // Don't blur if not active
    if (!isActive) {
      return;
    }

    console.log('is open', isOpen);

    console.log('blur event', event);

    if (isOpen) {
      handleClose();
    }
    document.activeElement.blur();
  };
  const [hoveredItem, setHoveredItem] = useState(null);

  const handleOnSelect = (newSelectedItem) => {
    console.log('1');
    setOpen(false);
    setSelectedItem(items.find((item) => item.objectId === newSelectedItem.objectId));
    onSelect(newSelectedItem);
    // TODO set the restaurant on the form
  };

  const handleOpen = () => {
    setPreviousSelectedItem(selectedItem);
    setSelectedItem(null);
    setOpen(true);
  };

  const handleClose = () => {
    setHoveredItem(null);
    setOpen(false);
    setInputFocus(false);
  };

  // TODO this needs to be in useEffect
  if (!isActive && isOpen) {
    console.log('no longer open');
    handleClose();
  }

  // const handleOnClose = () => {
  //   // If clicked out without setting anything, return to the previously selected item
  //   if (!selectedItem && previousSelectedItem) {
  //     setSelectedItem(previousSelectedItem);
  //   }
  //   setOpen(false);
  // };

  const handleOnType = (value) => {
    setInput(value);
    setWaiting(true);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setTypingTimeout(
      setTimeout(() => {
        searchRestaurants(value);
        setWaiting(false);
      }, 300),
    );
  };

  const wrapperRef = useRef(null);
  detectClickOutside(wrapperRef, handleClose);

  // TODO should probably be in useEffect
  // Return items that have a matching name or ID. Limit to 5 items
  const getFilteredItems = () => {
    if (!items || !input) {
      return [];
    }

    return items.slice(0, 5);
  };

  const filteredItems = getFilteredItems();
  const noItemsFound = input && !filteredItems.length;

  // TODO make this a hook
  const handleKeyPress = (event) => {
    // Return early if this is not the active element
    if (!isActive) {
      return;
    }

    // Prevent cursor from moving to start or end of input
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }

    if (isOpen) {
      const itemHeight = 54;
      if (event.key === 'ArrowDown') {
        if (hoveredItem === null) {
          setHoveredItem(0);
        } else {
          const nextItem = hoveredItem + 1;
          if (nextItem < filteredItems.length) {
            setHoveredItem(nextItem);

            listRef?.current?.scrollTo({
              top: hoveredItem * itemHeight,
              behavior: 'smooth',
            });
          }
        }
      } else if (event.key === 'ArrowUp') {
        const previousItem = hoveredItem - 1;
        if (previousItem >= 0) {
          setHoveredItem(previousItem);

          listRef?.current?.scrollTo({
            top: (hoveredItem - 1) * itemHeight,
            behavior: 'smooth',
          });
        }
      }

      // If press enter, select the hovered item
      if (event.key === 'Enter') {
        // If no hovered item, but only one filtered option, select that
        console.log(hoveredItem, filteredItems);
        if (hoveredItem === null && filteredItems.length === 1) {
          handleOnSelect(filteredItems[0]);
        } else if (hoveredItem !== null) {
          handleOnSelect(filteredItems[hoveredItem]);
        }
      }

      // Blur on escape without selecting
      if (event.key === 'Escape') {
        onBlur();
      }
    } else {
      // Down arrow should open dropdown if it's closed
      // eslint-disable-next-line no-lonely-if
      if (event.key === 'ArrowDown') {
        handleOpen();
        setHoveredItem(0);
      }
    }
  };

  // Add keyboard event listener to input
  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => document.removeEventListener('keydown', handleKeyPress);
  }, [hoveredItem, isOpen]);

  return (
    <Box
      className={`${classes.restaurantSelectorOuterContainer} ${className}`}
      style={{ ...style }}
    >
      {label && (
        <Box className='paragraph-small' mb='10px'>
          {label}
        </Box>
      )}

      <Box ref={wrapperRef} className={classes.restaurantSelectorContainer}>
        <Box
          className={`${classes.restaurantSelector} ${isOpen && classes.restaurantSelectorOpen}`}
          onClick={handleOpen}
        >
          <Box className={`${classes.restaurantSelectorContent} restaurant-selector-content`}>
            <Box className='text-field-inner'>
              <input
                ref={inputRef}
                onFocus={onFocus}
                onBlur={onBlur}
                autoCorrect='none'
                autoCapitalize='words'
                autoComplete='new-password'
                className={classes.textFieldInput}
                type='text'
                value={selectedItem?.name || input || ''}
                placeholder={placeholder}
                onChange={(e) => handleOnType(e.target.value)}
              />
            </Box>
            <Box
              onClick={(e) => {
                e.preventDefault();
                if (isOpen) {
                  handleClose();
                } else {
                  setInputFocus();
                  handleOpen();
                }
              }}
            >
              {isOpen ? (
                <UpArrowSVG style={{ marginBottom: '2px' }} />
              ) : (
                <UpArrowSVG style={{ marginBottom: '1px', transform: 'rotate(180deg)' }} />
              )}
            </Box>
          </Box>
        </Box>
        <Box
          className={`${classes.menu} restaurant-selector-menu ${
            isOpen ? classes.dropdownVisible : classes.dropdownHidden
          }`}
          // onClick={(e) => e.preventDefault()}
        >
          <>
            {(loading || waiting) && noItemsFound && (
              <Box p='20px' style={{ textAlign: 'center' }}>
                Loading...
              </Box>
            )}
            {!loading && !waiting && noItemsFound && (
              <Box p='20px' style={{ textAlign: 'center' }}>
                No restaurants found containing &apos;{input}&apos;
              </Box>
            )}
            {(input === '' || input === null) && (
              <Box p='20px' style={{ textAlign: 'center' }}>
                Start typing to search for restaurants
              </Box>
            )}
            {items &&
              filteredItems.map((item, i) => (
                <Box key={item.objectId}>
                  <Box
                    className={`${classes.menuItem} restaurant-selector-menu-item ${
                      i === hoveredItem ? classes.menuItemHovered : ''
                    }`}
                    onMouseDown={() => handleOnSelect(item)} // TODO this should be onClick
                    onMouseEnter={() => setHoveredItem(i)}
                  >
                    <Box
                      className='restaurant-selector-menu-item-text'
                      display='flex'
                      justifyContent='space-between'
                      width='100%'
                    >
                      <Box>
                        <Box mb='8px' className='paragraph-small'>
                          {item?.name}
                        </Box>
                        <Box
                          className='paragraph-xsmall'
                          style={{ color: '#6E6E6D', display: 'flex' }}
                        >
                          <span>{item?.region}</span>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  {i < filteredItems.length - 1 && <Box className={`${classes.spacer}`} />}
                </Box>
              ))}
          </>

          <Box
            className='restaurant-selector-create-new-item'
            onMouseEnter={() => setHoveredItem(null)}
          >
            {endAdornment}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

RestaurantSelector.defaultProps = {
  className: '',
  style: {},
  InputProps: {},
  label: '',
  placeholder: '',
  items: [],
  defaultValue: null,
  onSelect: () => {},
  searchRestaurants: () => {},
  loading: false,
};

RestaurantSelector.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  InputProps: PropTypes.shape({}),
  label: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.shape({}),
  onSelect: PropTypes.func,
  searchRestaurants: PropTypes.func,
  endAdornment: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      suburb: PropTypes.string,
      region: PropTypes.string,
      status: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};
